module.exports = __webpack_public_path__ + "static/hospitalitynet-37ec9f17857d463a18c48536b58ed7f2.png";